(function () {
  'use strict';

  function getSidebarMenu() {
    return document.getElementById('sidebar-menu');
  }

  function getOverlay() {
    return document.querySelector('.PageOverlay');
  }

  function setDrawerState(isOpen) {
    var drawer = getSidebarMenu();
    if (!drawer) return;

    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    var triggers = document.querySelectorAll('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]');
    for (var i = 0; i < triggers.length; i += 1) {
      triggers[i].setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    var overlay = getOverlay();
    if (overlay) {
      if (isOpen) {
        overlay.classList.add('is-visible');
      } else {
        overlay.classList.remove('is-visible');
      }
    }

    document.documentElement.classList.toggle('no-scroll', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }

  function toggleCollapsible(button) {
    var inner = button.nextElementSibling;
    if (!inner || !inner.classList.contains('Collapsible__Inner')) return;

    var expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');

    if (expanded) {
      inner.style.height = inner.scrollHeight + 'px';
      window.requestAnimationFrame(function () {
        inner.style.height = '0px';
      });
    } else {
      inner.style.height = inner.scrollHeight + 'px';
    }
  }

  function handleClick(event) {
    var openTrigger = event.target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]');
    if (openTrigger) {
      event.preventDefault();
      setDrawerState(true);
      return;
    }

    var closeTrigger = event.target.closest('[data-action="close-drawer"][data-drawer-id="sidebar-menu"]');
    if (closeTrigger) {
      event.preventDefault();
      setDrawerState(false);
      return;
    }

    var collapsible = event.target.closest('#sidebar-menu [data-action="toggle-collapsible"]');
    if (collapsible) {
      event.preventDefault();
      toggleCollapsible(collapsible);
      return;
    }

    var overlay = getOverlay();
    if (overlay && (event.target === overlay || overlay.contains(event.target))) {
      setDrawerState(false);
    }
  }

  function handleKeydown(event) {
    if (event.key === 'Escape') {
      var drawer = getSidebarMenu();
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        setDrawerState(false);
      }
    }
  }

  function initialise() {
    var drawer = getSidebarMenu();
    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'true');

    var inners = drawer.querySelectorAll('.Collapsible__Inner');
    for (var i = 0; i < inners.length; i += 1) {
      inners[i].style.overflow = 'hidden';
      inners[i].style.height = '0px';
      inners[i].style.transition = 'height 0.3s ease';
    }

    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();